/**
 * Forgot Password Page
 * Module 07 - Dashboard UI
 */

import React from 'react';
import ForgotPasswordForm from '../components/Auth/ForgotPasswordForm';

const ForgotPassword: React.FC = () => {
  return <ForgotPasswordForm />;
};

export default ForgotPassword;
